import CustomModalHeader from 'components/Custom/CustomModalHeader'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  Button,
  FormGroup,
  Input,
  Modal,
  ModalBody,
  Nav,
  NavItem,
  NavLink,
} from 'reactstrap'
import {
  createNewConversation,
  resetSelectedItems,
  setAssignSearchValue,
  setCurrentTab,
  setHideSelectedLocationGroups,
  setHideSelectedLocations,
  setHideSelectedOrgGroups,
  setHideSelectedRoles,
  setHideSelectedStores,
  setHideSelectedUsers,
  setShowSelectedLocationGroups,
  setShowSelectedLocations,
  setShowSelectedOrgGroups,
  setShowSelectedRoles,
  setShowSelectedStores,
  setShowSelectedUsers,
  toggleLocationGroups,
  toggleOrgGroups,
  toggleRoles,
  toggleStores,
  toggleUsers,
} from 'store/Chats/actions'
import { fetchGroups, fetchRoles } from 'store/Group/actions'
import AxiosInstance from 'utils/AxiosInstance'
import AssignTabs from '../AssignTabs'
import { createNewGroup } from 'store/Chats/actions'
import { addMembers } from 'store/Chats/actions'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'

export default function NewMessageModal({
  setshowNewMessageModal,
  showNewMessageModal,
  users,
  newGroup,
  addMember = false,
}) {
  const dispatch = useDispatch()
  const groups = useSelector((state) => state.groups)
  const [groupOrgs, setGroupOrgs] = useState([])
  const [soters, setStores] = useState([])

  const [slide, setSlide] = useState(0)

  const [groupPhotoPreview, setGroupPhotoPreview] = useState(null)
  const [groupName, setGroupName] = useState('')
  const [groupPhoto, setGroupPhoto] = useState(null)
  const location = useLocation()
  const conversationId = location.pathname?.split('/')?.at(2)

  const handlePhotoUpload = (e) => {
    const file = e.target.files[0]
    if (file) {
      setGroupPhoto(file)
      const reader = new FileReader()
      reader.onloadend = () => {
        setGroupPhotoPreview(reader.result)
      }
      reader.readAsDataURL(file)
    }
  }

  const languageRedux = useSelector((state) => state.language?.language?.data)
  const language = languageRedux || {}

  const { user: loggedInUser } = useSelector((store) => store.auth)
  const { creatingNewConversation, selectedLocationGroups, selectedUsers } =
    useSelector((store) => store.chat)
  const [message, setMessage] = useState('')

  const items = {
    groupOrgs: groupOrgs,
    users: users.usersExtendedDetails,
    stores: soters,
    locationGroups: groups.locationGroups,
    roles: groups.roles,
  }

  const fetchOrgGroups = () => {
    AxiosInstance.get(`/groups/orgs`).then((data) => setGroupOrgs(data))
  }

  const fetchStores = async () => {
    await AxiosInstance.get(`/stores`).then((stores) => {
      const formatedStores = []

      if (Array.isArray(stores)) {
        stores.map((item) => {
          formatedStores.push({
            ...item,
            status: item.status === 'Active' ? true : false,
          })
        })
      }

      setStores(formatedStores)
    })
  }

  useEffect(() => {
    fetchOrgGroups()
    fetchStores()
    dispatch(fetchGroups())
    dispatch(fetchRoles())
  }, [])

  // useEffect(() => {
  //     if (showSendWelcomeModal) {
  //         setSendingEmail(false)
  //     }
  // }, [showSendWelcomeModal])

  const toggleTabs = {
    toggleOrgGroups,
    toggleUsers,
    toggleLocationGroups,
    toggleStores,
    toggleRoles,
  }

  const hideSelectFunctions = {
    setHideSelectedOrgGroups,
    setHideSelectedLocationGroups,
    setHideSelectedLocations,
    setHideSelectedRoles,
    setHideSelectedStores,
    setHideSelectedUsers,
  }

  const showSelectFunctions = {
    setShowSelectedOrgGroups,
    setShowSelectedUsers,
    setShowSelectedStores,
    setShowSelectedRoles,
    setShowSelectedLocations,
    setShowSelectedLocationGroups,
  }

  useEffect(() => {
    if (loggedInUser?.access !== 1 || newGroup || addMember) {
      dispatch(
        setCurrentTab(
          null,
          'user',
          'selectedUsers',
          'users',
          'toggleUsers',
          'showSelectedUsers',
          'setShowSelectedUsers',
          'setHideSelectedUsers'
        )
      )
    }
  }, [loggedInUser?.access, dispatch, newGroup, addMember])

  return (
    <Modal
      toggle={() => setshowNewMessageModal(false)}
      isOpen={showNewMessageModal}
      centered
      size='lg'
    >
      <CustomModalHeader
        title={
          addMember
            ? 'Add Members'
            : !newGroup
            ? 'Send Message'
            : 'Create Group'
        }
        toggle={() => setshowNewMessageModal(false)}
      />
      <ModalBody className='position-relative' style={{ overflowX: 'hidden' }}>
        {slide === 0 && (
          <div className='d-flex flex-column align-items-start mb-5'>
            <div className='nav-wrapper col-12'>
              <Nav
                className='nav-fill flex-column flex-sm-row col-12 p-2 rounded '
                id='tabs-text'
                style={{ backgroundColor: '#f6f9fc' }}
                pills
                role='tablist'
              >
                {loggedInUser?.access === 1 && !newGroup && !addMember && (
                  <NavItem className='nav-items'>
                    <NavLink
                      aria-selected={users.currentTab === 'category'}
                      className={`mb-sm-3 mb-md-0 py-1 text-dark bg-transparent font-weight-bold 
                                                              ${
                                                                users.currentTab ===
                                                                'category'
                                                                  ? 'active-item'
                                                                  : 'nav-item'
                                                              }`}
                      onClick={(e) =>
                        dispatch(
                          setCurrentTab(
                            e,
                            'category',
                            'selectedOrgGroups',
                            'groupOrgs',
                            'toggleOrgGroups',
                            'showSelectedOrgGroups',
                            'setShowSelectedOrgGroups',
                            'setHideSelectedOrgGroups'
                          )
                        )
                      }
                      href='#pablo'
                      role='tab'
                      size='sm'
                    >
                      {language.general
                        ? language.general.category
                        : 'Category'}
                    </NavLink>
                  </NavItem>
                )}
                <NavItem>
                  <NavLink
                    aria-selected={users.currentTab === 'user'}
                    className={`mb-sm-3 mb-md-0 py-1 text-dark bg-transparent font-weight-bold 
                                                  ${
                                                    users.currentTab === 'user'
                                                      ? 'active-item'
                                                      : 'nav-item'
                                                  }`}
                    onClick={(e) =>
                      dispatch(
                        setCurrentTab(
                          e,
                          'user',
                          'selectedUsers',
                          'users',
                          'toggleUsers',
                          'showSelectedUsers',
                          'setShowSelectedUsers',
                          'setHideSelectedUsers'
                        )
                      )
                    }
                    href='#pablo'
                    role='tab'
                    color='none'
                  >
                    {language.general ? language.general.users : 'Users'}
                  </NavLink>
                </NavItem>
                {loggedInUser?.access === 1 && !newGroup && !addMember && (
                  <>
                    {' '}
                    <NavItem>
                      <NavLink
                        aria-selected={users.currentTab === 'location-group'}
                        className={`mb-sm-3 mb-md-0 py-1 text-dark bg-transparent font-weight-bold 
                                                              ${
                                                                users.currentTab ===
                                                                'location-group'
                                                                  ? 'active-item'
                                                                  : 'nav-item'
                                                              }`}
                        onClick={(e) =>
                          dispatch(
                            setCurrentTab(
                              e,
                              'location-group',
                              'selectedLocationGroups',
                              'locationGroups',
                              'toggleLocationGroups',
                              'showSelectedLocationGroups',
                              'setShowSelectedLocationGroups',
                              'setHideSelectedLocationGroups'
                            )
                          )
                        }
                        href='#pablo'
                        role='tab'
                      >
                        {language.general
                          ? language.general.location_categories
                          : 'Location Groups'}
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        aria-selected={users.currentTab === 'stores'}
                        className={`mb-sm-3 mb-md-0 py-1 text-dark bg-transparent font-weight-bold 
                                                  ${
                                                    users.currentTab ===
                                                    'stores'
                                                      ? 'active-item'
                                                      : 'nav-item'
                                                  }`}
                        onClick={(e) =>
                          dispatch(
                            setCurrentTab(
                              e,
                              'stores',
                              'selectedStores',
                              'stores',
                              'toggleStores',
                              'showSelectedStores',
                              'setShowSelectedStores',
                              'setHideSelectedStores'
                            )
                          )
                        }
                        href='#pablo'
                        role='tab'
                      >
                        {language.settings
                          ? language.settings.location
                          : 'Location'}
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        aria-selected={users.currentTab === 'job-title'}
                        className={`mb-sm-3 mb-md-0 py-1 text-dark bg-transparent font-weight-bold 
                                                              ${
                                                                users.currentTab ===
                                                                'job-title'
                                                                  ? 'active-item'
                                                                  : 'nav-item'
                                                              }`}
                        onClick={(e) =>
                          dispatch(
                            setCurrentTab(
                              e,
                              'job-title',
                              'selectedRoles',
                              'roles',
                              'toggleRoles',
                              'showSelectedRoles',
                              'setShowSelectedRoles',
                              'setHideSelectedRoles'
                            )
                          )
                        }
                        href='#pablo'
                        role='tab'
                      >
                        {language.settings
                          ? language.settings.assign_job_title
                          : 'Job Title'}
                      </NavLink>
                    </NavItem>{' '}
                  </>
                )}
              </Nav>
            </div>
            <AssignTabs
              items={items[users.currentItems]}
              toggleItem={toggleTabs[users.currentToggleFunction]}
              selectedItems={users.currentSelectedItems}
              mainProps={users}
              assignSearchValue={users.assignSearchValue}
              setHideSelectedItems={
                hideSelectFunctions[users.currentHideSelectedItemsFunction]
              }
              setShowSelectedItems={
                showSelectFunctions[users.currentShowSelectedItemsFunction]
              }
              showSelectedItems={users[users.currentShowSelectedItems]}
              // language={props.language}
              resetSelectedItems={resetSelectedItems}
              setCurrentTab={setCurrentTab}
              setAssignSearchValue={setAssignSearchValue}
              enableCategories={true}
              resetModal={users.toggleModal}
            />
          </div>
        )}
        {slide === 1 && (
          <div>
            {/* Group Photo Upload */}
            <div
              className='mx-auto mb-4'
              style={{
                width: 150,
                height: 150,
                border: '2px dashed #ccc',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'relative',
                cursor: 'pointer',
              }}
              onClick={() =>
                document.getElementById('group-photo-input').click()
              }
            >
              {groupPhotoPreview ? (
                <img
                  src={groupPhotoPreview}
                  alt='Group'
                  style={{
                    width: '100%',
                    height: '100%',
                    borderRadius: '50%',
                    objectFit: 'cover',
                  }}
                />
              ) : (
                <i
                  className='fa fa-camera'
                  style={{ fontSize: 32, color: '#888' }}
                />
              )}
              <input
                id='group-photo-input'
                type='file'
                accept='image/*'
                style={{ display: 'none' }}
                onChange={handlePhotoUpload}
              />
            </div>
            <FormGroup className='ml-0'>
              <Input
                id='exampleFormControlInput1'
                name='last_name'
                placeholder='Group name'
                type='text'
                style={{ height: '37px' }}
                value={groupName}
                onChange={(e) => setGroupName(e.target.value)}
              />
            </FormGroup>
          </div>
        )}

        {!newGroup && !addMember ? (
          <div className='d-flex'>
            <Input
              placeholder='Type a message...'
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            />
            <Button
              color='info'
              className='ml-3'
              type='button'
              onClick={() => {
                if (!message.trim()) {
                  return
                }
                dispatch(createNewConversation(message)).then(() => {
                  setshowNewMessageModal(false)
                  setMessage('')
                })
              }}
              disabled={!message.trim()}
            >
              {creatingNewConversation ? 'Sending...' : 'Send'}
            </Button>
          </div>
        ) : null}
        {newGroup ? (
          <div
            className='ml-auto w-100 justify-content-end d-flex'
            // style={{ position: 'absolute', bottom: '10px' }}
          >
            {slide > 0 && (
              <button
                className='btn btn-info mr-auto'
                onClick={() => setSlide(slide - 1)}
              >
                Previous
              </button>
            )}
            {slide === 1 ? (
              <button
                disabled={!selectedUsers.length}
                className='btn btn-info'
                onClick={() => {
                  dispatch(createNewGroup(groupName, groupPhoto))
                  setshowNewMessageModal(false)
                }}
              >
                Create Group
              </button>
            ) : (
              <button
                disabled={!selectedUsers.length}
                className='btn btn-info'
                onClick={() => setSlide(slide + 1)}
              >
                Next
              </button>
            )}
          </div>
        ) : null}
        {addMember ? (
          <div className='ml-auto w-100 justify-content-end d-flex'>
            <button
              onClick={() => {
                dispatch(addMembers(conversationId))
                setshowNewMessageModal(false)
              }}
              className='btn btn-info ml-auto'
            >
              Add
            </button>
          </div>
        ) : null}
      </ModalBody>
    </Modal>
  )
}
